import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeNegativeSign'
})
export class RemoveNegativeSignPipe implements PipeTransform {
  transform(value: string | number): string {
    let stringValue = value || '';
    if(typeof stringValue === 'number') {
        stringValue = (stringValue || '').toString();
    }
    if (typeof stringValue === 'string' && stringValue.startsWith('-')) {
      // Remove the negative sign at the beginning of the string
      return stringValue.substring(1);
    }

    return stringValue;
  }
}